import React from 'react';
import { BookCard, BookProps } from './BookCard';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
const RECOMMENDED_BOOKS: BookProps[] = [{
  id: 'r1',
  title: 'Diseño de Interfaces Modernas',
  author: 'Pablo G.',
  price: 24.99,
  rating: 5.0,
  color: 'bg-gradient-to-br from-violet-600 to-purple-900',
  category: 'Tecnología'
}, {
  id: 'r2',
  title: 'La Psicología del Dinero',
  author: 'Morgan H.',
  price: 19.5,
  rating: 4.9,
  color: 'bg-gradient-to-br from-slate-800 to-black',
  category: 'Negocios'
}];
export function Recommended() {
  return <section id="recomendados" className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-162">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-indigo-50/50 border border-indigo-100 rounded-3xl p-8 md:p-12" data-id="element-163">
        <div className="flex items-center gap-3 mb-8" data-id="element-164">
          <div className="p-2 bg-indigo-100 rounded-lg text-indigo-600" data-id="element-165">
            <Sparkles className="w-6 h-6" data-id="element-166" />
          </div>
          <div data-id="element-167">
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900" data-id="element-168">
              Selección del Editor
            </h2>
            <p className="text-slate-600 mt-1" data-id="element-169">
              Lecturas imprescindibles que no te puedes perder.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-170">
          {RECOMMENDED_BOOKS.map((book, index) => <BookCard key={book.id} book={book} featured={true} delay={index * 0.2} data-id="element-171" />)}
        </div>
      </motion.div>
    </section>;
}